var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c("div", { staticClass: "confirm-container big gray" }, [
        _c("div", { staticClass: "confirm-wrapper" }, [
          _c("div", { staticClass: "title" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("tradeAssets.confirmTable.title")))
            ]),
            _vm._v(" "),
            _c("span", {
              staticClass: "close-icon __pointer",
              on: { click: _vm.close }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "__tb" }, [
            _c(
              "div",
              { staticClass: "__tb_row __tb_head __pointer" },
              _vm._l(_vm.$t("tradeAssets.confirmTable.heads"), function(h) {
                return _c("div", { key: h, staticClass: "__tb_cell" }, [
                  _vm._v(_vm._s(h))
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.detailList || !_vm.detailList.length,
                    expression: "!detailList || !detailList.length"
                  }
                ],
                staticClass: "__tb_content __tb_content_no_data"
              },
              [
                _c("div", { staticClass: "__tb_no_data" }, [
                  _c("div", [_vm._v(_vm._s(_vm.$t("hint.noData")))])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "__tb_content" },
              _vm._l(_vm.detailList, function(v, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "__tb_row __pointer __tb_content_row"
                  },
                  _vm._l(v, function(item, j) {
                    return _c("div", { key: j, staticClass: "__tb_cell" }, [
                      _vm._v(_vm._s(item))
                    ])
                  }),
                  0
                )
              }),
              0
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }